import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';

export abstract class ActionBarBehavior {
  abstract isActionBar(type: ActionBarType): boolean;
  abstract executeAction(actionBarConfig: ActionBarConfig, selectedRecords?: any[], additionalParams?: any);
}
